"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var MyNavLink = /** @class */ (function (_super) {
    tslib_1.__extends(MyNavLink, _super);
    function MyNavLink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MyNavLink.prototype.render = function () {
        var _a = this.props, href = _a.href, exact = _a.exact, strict = _a.strict, activeClassName = _a.activeClassName, className = _a.className, children = _a.children;
        return (react_1.default.createElement(react_router_dom_1.Route, { path: href, exact: exact, strict: strict, children: function (_a) {
                var location = _a.location, match = _a.match;
                var isActive = !!match;
                return (react_1.default.createElement("a", { href: href, className: isActive
                        ? [className, activeClassName].filter(function (i) { return i; }).join(' ')
                        : className }, children));
            } }));
    };
    return MyNavLink;
}(react_1.default.Component));
exports.MyNavLink = MyNavLink;
